import React, { type FC, type PropsWithChildren } from 'react'

import { FilterSunpoint } from '@components/organisms/StudioFilter/StudioFilter'

import { categoryLinks } from '@helper/categoryLinks'
import { type PropsWithClassName } from '@helper/PropsWithClassName'
import { themeSunpoint } from '@helper/theme'

import { type Category } from '@definitions/types/symfonyTypes'

import { Root, ServiceItem, ServiceLink } from './ServiceList.styles'

interface Props extends PropsWithClassName {
  items: Category[]
  neutral?: boolean
  parentName: string
}

const ServiceList: FC<PropsWithChildren<Props>> = (
  props: PropsWithChildren<Props>
): React.JSX.Element => {
  const { className, items, neutral = false, parentName } = props

  let color: string = themeSunpoint.palette.default.primary
  if (parentName === FilterSunpoint.KOSMETIK) {
    color = themeSunpoint.palette.default.grey
  } else if (parentName === FilterSunpoint.BODYFORMING) {
    color = themeSunpoint.palette.default.secondary
  } else if (parentName === FilterSunpoint.BRAEUNE) {
    color = themeSunpoint.palette.default.primary
  }

  return (
    <Root className={className} data-testid={'service-list-root'}>
      {items.map((item) => {
        if (!item || item.name === 'SUNPOINT Filialkette') {
          return null
        }
        const href: string = categoryLinks[item.name]
        return (
          <ServiceItem key={item.id}>
            <ServiceLink
              color={color}
              href={item.link}
              neutral={neutral}
              aria-disabled={!href}
            >
              {item.name}
            </ServiceLink>
          </ServiceItem>
        )
      })}
    </Root>
  )
}

export { ServiceList }
